import { defineComponent as _defineComponent } from 'vue'
import { PropType, Ref, ref } from 'vue'
import { useGameStore } from '@/store/useGameStore'
import QuizzControl from '@/components/task/enig/QuizzControl.vue'
import Button from '@/components/base/Button.vue'
import { Enig, Thumbs } from '@/templates/slplus/structure/questionModels'
import { soundIsPlaying, stopSounds } from '@/utilities'

import omarSpeaksImage from '@/assets/omar/OMAR-GLAD.svg'

import berry from '@/assets/tasks/enig/blueberrie.svg'
import spinach from '@/assets/tasks/enig/spinach.svg'
import mushroom from '@/assets/tasks/enig/mushroom.svg'
import flower from '@/assets/tasks/enig/flower.svg'
import glasses from '@/assets/tasks/enig/glasses2.svg'

import video from '@/assets/tasks/video.svg'
import instructions from '@/assets/tasks/instructions.svg'
import placement from '@/assets/tasks/placement.svg'

type ImageKey = 0 | 1 | 2 | 3
interface Location {
  x: string
  y: string
}
type Images = {
  [key in ImageKey]: { src: string; loc: Location }
}
type Results = {
  [key in ImageKey]: { answer: Thumbs; correct: boolean } | undefined
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Quizz4Way',
  props: {
  question: { required: true, type: Object as PropType<Enig> },
  round: { required: true, type: Number },
},
  emits: ['review', 'done', 'playsound', 'stopsound'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props




const gameStore = useGameStore()
const players = gameStore.getters.playersInSelectedGame

const results: Ref<Results> = ref({
  0: undefined,
  1: undefined,
  2: undefined,
  3: undefined,
})
const imageKeys: ImageKey[] = [0, 1, 2, 3]
const agreeImages: Ref<Images> = ref({
  0: { src: berry, loc: { x: '0px', y: '0px' } },
  1: { src: spinach, loc: { x: '0px', y: '0px' } },
  2: { src: mushroom, loc: { x: '0px', y: '0px' } },
  3: { src: flower, loc: { x: '0px', y: '0px' } },
})
const disagreeImages: Ref<Images> = ref({
  0: { src: glasses, loc: { x: '0px', y: '0px' } },
  1: { src: glasses, loc: { x: '0px', y: '0px' } },
  2: { src: glasses, loc: { x: '0px', y: '0px' } },
  3: { src: glasses, loc: { x: '0px', y: '0px' } },
})

function randomLocation(): Location {
  const x = Math.floor(Math.random() * 300) + 'px'
  const y = Math.floor(Math.random() * 300) + 'px'
  return { x, y }
}

function clickAnswer(playerIndex: ImageKey, answer: Thumbs) {
  if (results.value[playerIndex]) return // Disallow answering more than once
  console.log(`Player: ${playerIndex} answer: ${answer}`)

  // Scoring
  const playerAnswerAsBoolean = answer === Thumbs.up
  const correct = props.question.mening[props.round].statementCorrect === playerAnswerAsBoolean
  results.value[playerIndex] = { answer, correct }

  // Put an image on Omar based on answer given
  if (playerAnswerAsBoolean) agreeImages.value[playerIndex].loc = randomLocation()
  else disagreeImages.value[playerIndex].loc = randomLocation()
  const r = Object.values(results.value)
  if (r.filter((answer) => !!answer).length === players.value.length)
    setTimeout(() => {
      emit('done', results)
    }, 1500)
}

const __returned__ = { props, emit, gameStore, players, results, imageKeys, agreeImages, disagreeImages, randomLocation, clickAnswer, QuizzControl, Button, Thumbs, soundIsPlaying, stopSounds, omarSpeaksImage, video, instructions, placement }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})